const router = [
  {
    path: '/login/:tid',
    name: 'Login',
    component: () => import('@/views/index/Login.vue'),
    meta: {
      title: '登录',
      checkToken: false
    }
  },
  /**
   * 入口页面
   * */
  {
    path: '/entry/page',
    name: 'EntryPage',
    component: () => import('@/views/index/EntryPage.vue'),
    meta: {
      title: '',
      checkToken: true,
      bottomSafeAreaClass: 'bg-page-gray'
    }
  }
];
export default router;
